export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const MIN_IMAGE_DIMENSION = 400; // Minimum 400x400 pixels
export const MAX_IMAGE_DIMENSION = 4000; // Maximum 4000x4000 pixels

export const validateImageFile = (file) => {
  const errors = [];

  if (file.size > MAX_FILE_SIZE) {
    errors.push('profilePictureInvalidSize');
  }

  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    errors.push('profilePictureInvalidType');
  }

  return errors;
};

export const validateImageDimensions = file => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = (e) => {
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;

      if (width < MIN_IMAGE_DIMENSION || height < MIN_IMAGE_DIMENSION) {
        reject(new Error('profilePictureInvalidDimensionsTooSmall'));
        return;
      }

      if (width > MAX_IMAGE_DIMENSION || height > MAX_IMAGE_DIMENSION) {
        reject(new Error('profilePictureInvalidSize'));
        return;
      }

      resolve({ width, height });
    };

    img.onerror = () => {
      reject(new Error('profilePictureInvalidType'));
    };

    img.src = e.target.result;
  };

  reader.onerror = () => {
    reject(new Error('profilePictureInvalidType'));
  };

  reader.readAsDataURL(file);
});

export const validateProfileImage = async (file) => {
  const fileErrors = validateImageFile(file);

  if (fileErrors.length > 0) {
    return { valid: false, errors: fileErrors };
  }

  try {
    await validateImageDimensions(file);
    return { valid: true, errors: [] };
  } catch (error) {
    return { valid: false, errors: [error.message] };
  }
};
